import { useTranslations } from "@jugl-web/utils";
import { useMemo } from "react";

export const useInvoiceTypeToLabelDictionary = () => {
  const { t } = useTranslations();

  const dict = useMemo(
    () => ({
      invoice: t({
        id: "invoices.type.invoice",
        defaultMessage: "Invoice",
      }),
      proforma: t({
        id: "invoices.type.proforma",
        defaultMessage: "Proforma",
      }),
      estimate: t({
        id: "invoices.type.estimate",
        defaultMessage: "Estimate",
      }),
      purchase_order: t({
        id: "invoices.type.purchase_order",
        defaultMessage: "Purchase Order",
      }),
    }),
    [t]
  );

  return dict;
};
